<template>
  <div class="self-analysis">
    <div class="commonBox">
      <div class="titleBox">行动计划：</div>
      <div class="tableBox">
        <div class="table-head">
          <div class="headTextBox">
            <div class="headtext headtext1">类型</div>
            <div class="headtext">目标及主要任务</div>
            <div class="headtext">具体行动方案</div>
            <div class="headtext">优劣势分析及对策</div>
            <div class="headtext headtext2">资源需求（培训、辅导等）</div>
            <div class="headtext">开始日期</div>
            <div class="headtext">结束日期</div>
            <div class="headtext headtext4">操作</div>
          </div>
          <div class="addbtn">
            <div @click="EvaluationListAdd" class="addbtnText">+添加</div>
          </div>
        </div>
        <div class="table-body">
          <div
            class="bodyTr"
            @click="selectIndex = index"
            :class="{
              bodyTrBot: pageData.WorkPlanList.length > 1,
            }"
            v-for="(item, index) in pageData.WorkPlanList"
            :key="index"
          >
            <div class="bodyTd bodyTd1">
              <el-select v-model="item.PlanType" placeholder="请选择">
                <el-option
                  v-for="item in PlanTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="bodyTd">
              <el-input
                type="textarea"
                class="textarea"
                v-model="item.Task"
                autosize
              ></el-input>
            </div>
            <div class="bodyTd">
              <el-input
                type="textarea"
                class="textarea"
                v-model="item.PlanInfo"
                autosize
              ></el-input>
            </div>
            <div class="bodyTd">
              <el-input
                type="textarea"
                class="textarea"
                v-model="item.Analysis"
                autosize
              ></el-input>
            </div>
            <div class="bodyTd bodyTd2">
              <el-input
                type="textarea"
                class="textarea"
                v-model="item.Requirement"
                autosize
              ></el-input>
            </div>

            <div class="bodyTd">
              <el-date-picker
                v-model="item.StartDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                class="uni-input"
              >
              </el-date-picker>
            </div>
            <div class="bodyTd">
              <el-date-picker
                v-model="item.EndDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                class="uni-input"
              >
              </el-date-picker>
            </div>
            <div class="bodyTd bodyTd4">
              <el-button type="text" @click="handDelete(index)">删除</el-button>
            </div>
          </div>
          <template
            v-if="!pageData.WorkPlanList || pageData.WorkPlanList.length === 0"
          >
            <div class="notDataDiv">暂无目标设定</div>
          </template>
        </div>
      </div>
    </div>
    <div class="commonBox">
      <div class="titleBox">职业生涯规划调整事项：</div>
      <div class="textBox">
        <el-input
          type="textarea"
          class="textarea"
          v-model="pageData.ReasonOfCareerChangedItems"
          autosize
        ></el-input>
      </div>
    </div>
    <div class="commonBox">
      <div class="titleBox">升学方式：</div>
      <div class="textBox">
        <el-input
          type="textarea"
          class="textarea"
          v-model="pageData.UpgradePath"
          autosize
        ></el-input>
      </div>
    </div>
    <div class="commonBox">
      <div class="titleBox">指导老师：</div>
      <div class="textBox">
        <el-input
          type="textarea"
          class="textarea"
          v-model="pageData.PlaningPersonName"
          autosize
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import local_json from "../my-components/private_info_json.js";
export default {
  props: {
    detailData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      //图片地址
      imagesBaseURL: this.$store.state.imagesBaseURL,
      pageData: {
        WorkPlanList: [],
        ReasonOfCareerChangedItems: "",
        UpgradePath: "",
        PlaningPersonName: "",
      },
      PlanTypeList: local_json.PlanTypeList,
      selectIndex: 0,
    };
  },
  watch: {
    detailData(val) {
      if (this.detailData) {
        let temp = this.detailData.WorkPlanList;
        if (temp && temp.length !== 0) {
          temp.forEach((item) => {
            item.EndDate = item.EndDateStr;
            item.StartDate = item.StartDateStr;
          });
        }

        this.pageData = this.detailData;
      }
    },
  },
  mounted() {
    // this.inte()
  },
  methods: {
    inte() {
      if (this.detailData) {
        this.pageData.WorkPlanList = this.detailData.WorkPlanList;
      }
    },
    EvaluationListAdd() {
      this.pageData.WorkPlanList.push({
        PlanType: 3,
        StartDate: "",
        EndDate: "",
        Task: "",
        PlanInfo: "",
        Analysis: "",
        Requirement: "",
        Sort: 0,
      });
    },
    handleSelect(val) {
      this.pageData.WorkPlanList[this.selectIndex].PlanType =
        this.PlanTypeList[val.detail.value].value;
    },
    selectStartData(val) {
      this.pageData.WorkPlanList[this.selectIndex].StartDate = val.detail.value;
    },
    selectStartEndDate(val) {
      this.pageData.WorkPlanList[this.selectIndex].EndDate = val.detail.value;
    },
    handDelete(index) {
      this.$confirm("确定删除该项吗？", "注意！", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.pageData.WorkPlanList.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.self-analysis {
  color: #fff;
}

.commonBox {
  .titleBox {
    line-height: 28px;
    color: #666;
    font-weight: bold;
    margin: 8px 0px;
  }
  .textBox {
    width: 100%;
    line-height: 1.5;
    min-height: 48px;
    .textarea {
      background: #eef2f6;
      width: 100%;
    }
  }

  .tableBox {
    width: 100%;
    color: #a8c2ff;
    font-size: 14px;
    position: relative;
    z-index: 1;
    .addbtn {
      position: absolute;
      top: -57px;
      right: 0;
      width: 120px;
      color: rgba(var(--themecolor),0.8);
      height: 52px;
      text-align: center;
      border-radius: 5px 5px 0px 0px;
      background: #ddd;
      font-weight: bold;
      z-index: -1;
      cursor: pointer;
      .addbtnText {
        line-height: 52px;
        height: 52px;
      }
    }
    .table-head {
      width: 100%;
      height: 48px;
      background: rgba(var(--themecolor),0.8);
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      padding: 12px 0px;

      .headTextBox {
        width: 100%;
        display: flex;
      }
    }

    .headtext {
      width: 14%;
      height: 24px;
      line-height: 24px;
      color: #eef2f6;
      text-align: center;
      border-left: #ddd 1px solid;
    }

    .headtext1 {
      width: 8%;
      border-left: none;
    }

    .headtext2 {
      width: 17%;
    }

    .headtext4 {
      width: 6%;
    }

    .table-body {
      width: 100%;
      background: #ddd;
      border-radius: 0px 0px 5px 5px;

      .bodyTr {
        display: flex;

        .bodyTd {
          width: 14%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 400;
          padding: 10px 4px;
          height: auto;
          // min-height: 54px;
          border-left: #ddd 1px solid;
          .textarea {
            width: 100%;
            text-align: left;
          }
        }

        .bodyTd1 {
          width: 8%;
          border-left: none;
        }

        .bodyTd2 {
          width: 17%;
        }

        .bodyTd4 {
          width: 6%;
        }
      }

      .bodyTrBot {
        border-bottom: #ddd 1px solid;
      }
    }
  }
}

.notDataDiv {
  height: 48px;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  color: #31415e;
  opacity: 0.4;
}
</style>
